import React from 'react';
import isEqual from 'lodash/isEqual';

import { arrayMove } from '@dnd-kit/sortable';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';

type Item = { id: string | number };

type Props = {
  children?: React.ReactNode;
  listData: Item[];
  onDragEnd: (updatedList: Item[]) => void;
};

const DndContextComponent: React.FC<Props> = ({ children, ...props }) => {
  const { listData, onDragEnd } = props;

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event: DragEndEvent) => {
    if (!event.over) return;

    const { active, over } = event;

    const oldIndex = listData.findIndex((item) => item.id === active.id);
    const newIndex = listData.findIndex((item) => item.id === over.id);

    const updatedList = arrayMove(listData, oldIndex, newIndex);

    if (!isEqual(updatedList, listData)) {
      onDragEnd(updatedList);
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      {children}
    </DndContext>
  );
};

export default DndContextComponent;
